export default __webpack_public_path__ + "static/media/EM0210.34I-21000_-14989_0.8f20138f.jpg";